import axios from "axios";
import toast from 'react-hot-toast';

export const DeekSeekIntegration = async (fieldName, content) => {
  try {
    const accessToken = localStorage.getItem('NCProAccessToken'); //Will move to Redux later.
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/ai/generate-response`,
      { fieldName, content },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        },
        timeout: 60000,
      }
    );
    return response.data.message;
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      toast.error('The AI response is taking longer than expected. Please try again later.');
    } else {
      console.error('Error:', error);
      toast.error('Something went wrong.');
    }
  }
};

export const relevantRootCauseResponse = async (data) => {
  try {
    const accessToken = localStorage.getItem('NCProAccessToken');
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/ai/relevant-root-cause`,
      {
        "whatWentWrong": data.what_went_wrong,
        "processRootCauseDescription": data.process_root_cause_description,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`
        },
        timeout: 60000,
      }
    );
    return response.data.message;
  } catch (error) {
    if (error.code === 'ECONNABORTED') {
      toast.error('The AI response is taking longer than expected. Please try again later.');
    } else {
      console.error('Error:', error);
      toast.error('Something went wrong.');
    }
  }
};